const PerPageOption = {
  FIVE: 5,
  TEN: 10,
  TWENTY_FIVE: 25,
  FIFTY: 50,
  ONE_HUNDRED: 100,
};
export default PerPageOption;
